import i18n from '@translations';

import {
  ApiEndpoint,
  columnDirection,
  FormActionType,
  FormType,
  InputType,
  ServiceModalName,
  Translation,
} from '@enums';
import type { EndpointType, FormConfig, FormConfigMapping } from '@types';

interface GetCacheFormConfigParams {
  endpoint?: EndpointType;
  value?: string[];
}

export const getCacheFileExtensionFormConfig = ({
  endpoint = ApiEndpoint.DEFAULT,
  value = [],
}: GetCacheFormConfigParams): FormConfig => {
  const tForm: (key: string) => string = (key: string): string =>
    i18n.t(`${Translation.Configuration}:forms.cache.${key}`);

  const tButton: (key: string) => string = (key: string): string =>
    i18n.t(`${Translation.Configuration}:buttons.cache.${key}`);

  const tDescription: (key: string) => string = (key: string): string =>
    i18n.t(`${Translation.Description}:configuration.cache.${key}`);

  const tValidation: (key: string, content: string) => string = (key: string, content: string): string =>
    i18n.t(`${Translation.Validation}:format.${key}`, { content });

  const CACHE_FORM: FormConfigMapping = {
    [ApiEndpoint.DEFAULT]: {
      formType: FormType.CdnCache,
      formActionType: FormActionType.Save,
      endpoint: ApiEndpoint.DEFAULT,
      modalName: ServiceModalName.FormModal,
      label: {
        title: tForm('configureCacheFileExtension'),
        description: tDescription('configureCacheFileExtension'),
        confirmButton: tButton('configure'),
      },
      inputList: [
        {
          name: 'extensions',
          defaultValue: [],
          inputType: InputType.Area,
          isStringArray: true,
          placeholder: tValidation('block', tForm('enterYourCacheFileExtension')),
          label: tForm('configureCacheFileExtension'),
          direction: columnDirection.Column,
          fullWidth: true,
          centerItem: true,
          withoutLabel: true,
          className: 'space-y-3',
          textInputClassName: 'min-h-40',
          value,
        },
      ],
    },
  };

  return (CACHE_FORM[endpoint] ?? CACHE_FORM[ApiEndpoint.DEFAULT]) as FormConfig;
};
